import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Text } from '@naf/text';
import { colors } from '@naf-simba/theme';

export const HeadContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-left: calc(${spacing.space12} + 2px);
`;

export const HeaderText = styled(Text)`
  margin: 0;
  font-size: 2rem;
  line-height: 2.5rem;
`;

export const IngressContainer = styled.div`
  margin-top: ${spacing.space32};
  margin-bottom: 0;

  & * {
    font-size: 1.25rem;
    line-height: 2rem;
    margin-top: 0;
    font-style: italic;
  }

  & > * {
    margin: 0;
  }

  & > * + * {
    margin-top: 1em;
  }
`;

export const StyledTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  > p {
    margin: 0 ${spacing.space8};
  }
`;

export const ButtonContainer = styled.div`
  margin-bottom: ${spacing.space24};
  text-align: center;
`;

export const NewsHR = styled.hr<{ isNew?: boolean; size: 'small' | 'large' }>`
  border: 0;
  margin: 0 ${spacing.space4};
  border-top: 1px solid ${({ isNew }) => (isNew ? colors.secondary[500] : nafColor.neutral.neutral3)};
  ${({ size }) =>
    size === 'large'
      ? css`
          flex-grow: 1;
        `
      : css`
          width: 16px;
        `}
`;

export const EmptyHR = styled.hr`
  border-top: 1px solid ${nafColor.neutral.neutral3};
  margin: 0 ${spacing.space4};
  width: 100%;
`;

export const HRLine = styled.hr`
  border: 0;
  border-top: 3px solid ${nafColor.signature.yellow};
  width: 96px;
  margin: ${spacing.space40} 0 ${spacing.space32} 0;
  color: ${nafColor.signature.yellow};
`;

export const BottomHR = styled(HRLine)`
  margin-left: calc(${spacing.space12} + 2px);
  margin-top: ${spacing.space32};
  margin-bottom: 0;
`;

export const News = styled.div<{ $isNew?: boolean }>`
  border-left: 1px solid ${({ $isNew }) => ($isNew ? colors.secondary[500] : nafColor.neutral.neutral3)};
  padding: ${spacing.space12} 0 ${spacing.space24} ${spacing.space12};

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }

  > div > figure {
    margin: 0;
  }

  > div > figure + figure {
    margin: 0;
    margin-top: ${spacing.space24};
  }
`;

export const Dot = styled.div<{ $color: string }>`
  border-radius: 9999px;
  margin-left: -5px;
  min-width: 11px;
  max-width: 11px;
  height: 11px;
  background-color: ${({ $color }) => $color};
`;

export const Bottom = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${spacing.space32};
  margin-left: calc(${spacing.space12} + 2px);

  > span {
    margin-left: ${spacing.space24};
  }
`;

export const SubtleText = styled(Text)`
  color: ${nafColor.neutral.neutral4};
`;

export const EmptyFeedItem = styled(News)`
  color: ${nafColor.neutral.neutral4};
`;
